/**
 * コース詳細に表示する学習時間。
 *
 * レッスン数から一律に推定すると、短い体験コースも長い実践コースも
 * 同じ換算になってしまうため、登録されている所要時間を使う。
 */
export function sumCourseLessonDurations(
  sections: ReadonlyArray<{
    lessons: ReadonlyArray<{ duration: number | null | undefined }>;
  }>,
): number {
  return sections.reduce(
    (total, section) =>
      total +
      section.lessons.reduce(
        (sectionTotal, lesson) =>
          sectionTotal +
          (typeof lesson.duration === "number" && lesson.duration > 0
            ? lesson.duration
            : 0),
        0,
      ),
    0,
  );
}

/**
 * 体験者が読み取りやすい粒度に丸める。
 * 1時間未満は15分刻みで切り上げ、1時間以上は30分刻みの近似値にする。
 * 25分のコースを「約30分」と表示でき、長時間コースも細かい小数を避けられる。
 */
export function formatCourseDuration(totalMinutes: number): string {
  if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) return "-";

  if (totalMinutes < 60) {
    const minutes = Math.ceil(totalMinutes / 15) * 15;
    return `約${minutes}分`;
  }

  const hours = Math.max(1, Math.round(totalMinutes / 30) / 2);
  return `約${Number.isInteger(hours) ? hours : hours.toFixed(1)}時間`;
}

/**
 * The post-split Algorithms course has 51 reviewed lessons but no authored
 * duration metadata. Keep the legacy 135-lesson topology unchanged and avoid
 * turning missing source data into a made-up duration after the split.
 */
export function hasMissingSourceCourseDuration(input: {
  slug: string;
  lessonCount: number | null | undefined;
  estimatedHours: number | null | undefined;
  knownDurationMinutes?: number | null;
}): boolean {
  return (
    input.slug === "cs-algorithms" &&
    input.lessonCount === 51 &&
    !(typeof input.estimatedHours === "number" && input.estimatedHours > 0) &&
    !(
      typeof input.knownDurationMinutes === "number" &&
      input.knownDurationMinutes > 0
    )
  );
}
